import { createFileRoute } from "@tanstack/react-router";
import { Page } from "#/components/page";

// Portal parity: `_protected.$school.dashboard` renders an empty `Page` shell (content TBD).
export const Route = createFileRoute("/$locale/{-$schoolyear}/_authenticated/$school/dashboard")({
  component: DashboardPage,
});

function DashboardPage() {
  return <Page />;
}
